/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var YesNoPreferNotToAnswer;

(function (YesNoPreferNotToAnswer) {
  YesNoPreferNotToAnswer["YES"] = "Yes";
  YesNoPreferNotToAnswer["NO"] = "No";
  YesNoPreferNotToAnswer["PREFER_NOT_TO_ANSWER"] = "Prefer not to answer";
})(YesNoPreferNotToAnswer || (YesNoPreferNotToAnswer = {}));